import ATS from 'modules/ATS/Container/index.js'
import UserSignin from 'modules/Auth/Container/index'
import Courses from 'modules/Courses/Container/index'
import Dashboard from 'modules/Dashboard/Container/index'
import DashboardDrive from 'modules/Dashboard/Partials/DashboardDrive/index'
import DashboardRoles from 'modules/Dashboard/Partials/DashboardRoles/index'
import ViewIndividualDrive from 'modules/Dashboard/Partials/DriveRoleTable/index'
// import Drive from 'modules/Drive/Container/index'
import DriveInfo from 'modules/DriveInfo/Container/index'
import EventRole from 'modules/Events/EventRole/Container/index'
import JobRoles from 'modules/JobRoles/Container/index'
import NewJobRole from 'modules/JobRoles/NewJobRole/Container/index'
import ManageProfile from 'modules/ManageProfile/Container/index'
import InstituteOnBoarding from 'modules/OnBoarding'
import Placement from 'modules/Placement/Container/index'
import Roles from 'modules/Roles/Container/index'
import ViewIndividualRole from 'modules/Roles/Partials/ViewIndividualRole/index'
import RuleEngine from 'modules/RuleEngine/Container/index'
import Settings from 'modules/Settings/Container/index'
import Students from 'modules/Students/Container/index'
import Users from 'modules/Users/Container/index'
import PageNotFound from 'routes/Components/PageNotFound'
import Corporate from '../../modules/Corporate'
import NewCorporate from '../../modules/Corporate/NewCorporate'
import Events from '../../modules/Events'
import NewEvent from '../../modules/Events/New Event'
import Drafts from '../../modules/Events/Partials/Drafts'
import JobPreviewIndex from '../../modules/JobPreview/Container/index'
import CompanyDetails from '../../modules/JobRoles/NewJobRole/CompanyDetails'
import RuleEngineDraft from '../../modules/RuleEngine/Components/RuleEngineDraft/Container'
import RulesCreationIndex from '../../modules/RuleEngine/Components/RulesCreationIndex/Container'
import SettingNewRules from '../../modules/RuleEngine/Components/SettingNewRules/Container'
import YetToSetRulesTable from '../../modules/RuleEngine/Components/YetToSetRulesTable/Container'
import TPODashboard from '../../modules/TPODashboard/Container'
import TPORequests from '../../modules/TPORequests/Container/index'
import Reports from '../../modules/Reports/Container/index'
import StudentReportContainer from '../../modules/Reports/Partials/StudentReports/Container/index'
import Approval from '../../modules/Approval'
import TPOApproval from '../../modules/TPOApproval'
import React, { Component } from 'react'
import { elements } from 'chart.js'
import ApprovalListing from '../../modules/TPOApproval/Components/ApprovalListing'
import StudentResume from '../../modules/TPOApproval/Components/StudentResume'
import AuditLog from 'modules/AuditLog/Container/index'
export const anonymous = [
  {
    routePath: '/signin',
    Component: UserSignin,
  },
  {
    routePath: '/onboarding',
    Component: InstituteOnBoarding,
  },
]

export const authenticated = [
  {
    routePath: '/activity-log',
    Component: AuditLog,
    navTitle: 'Activity Log',
  },
  {
    routePath: '/dashboard',
    Component: Dashboard,
  },
  {
    routePath: '/jobRoles/ats/:roleId',
    Component: ATS,
  },
  {
    routePath: '/corporate',
    Component: Corporate,
  },
  {
    routePath: '/corporate/newCorporate',
    Component: NewCorporate,
  },
  {
    routePath: '/corporate/editCorporate/:corporateId',
    Component: NewCorporate,
  },
  {
    routePath: '/jobRoles/jobPreview/:roleId',
    Component: JobPreviewIndex,
  },
  {
    routePath: '/dashboard/roles/:corpID',
    Component: DashboardRoles,
  },
  {
    routePath: '/dashboard/drives/:roleID/:corpID',
    Component: DashboardDrive,
  },
  {
    routePath: '/dashboard/roles/drive/:driveID/:roleID',
    Component: ViewIndividualDrive,
  },
  {
    routePath: '/students',
    Component: Students,
    navTitle: 'Students',
  },
  {
    routePath: '/roles',
    Component: Roles,
    navTitle: 'Roles',
  },
  {
    routePath: '/placement',
    Component: Placement,
    navTitle: 'Global',
  },
  {
    routePath: '/jobRoles',
    Component: JobRoles,
    navTitle: 'Global',
  },
  {
    routePath: '/jobRoles/newRole',
    Component: NewJobRole,
    navTitle: 'Global',
  },
  {
    routePath: '/jobRoles/editRole/:roleId',
    Component: NewJobRole,
    navTitle: 'Global',
  },
  {
    routePath: '/jobRoles/newRole/companyDetails',
    Component: CompanyDetails,
    navTitle: 'Global',
  },
  {
    routePath: '/tpoDashboard',
    Component: TPODashboard,
    navTitle: 'Global',
  },
  {
    routePath: '/approvals',
    Component: Approval,
    navTitle: 'Global',
  },
  {
    routePath: '/tpoApproval',
    Component: TPOApproval,
    navTitle: 'Global',
  },
  {
    routePath: '/tpoApproval/approval-listing',
    Component: ApprovalListing,
    navTitle: 'Global',
  },
  {
    routePath: '/tpoApproval/student-resume/:studentId',
    Component: StudentResume,
    navTitle: 'Global',
  },
  {
    routePath: '/roles/details',
    Component: ViewIndividualRole,
    navTitle: 'Roles',
  },
  // {
  //   routePath: '/drives',
  //   Component: Drive,
  //   navTitle: 'Drives',
  // },
  {
    routePath: '/drives/driveInfo',
    Component: DriveInfo,
    navTitle: 'Drives',
  },
  {
    routePath: '/ruleEngine',
    Component: RuleEngine,
    navTitle: 'Rule Engine',
  },
  {
    routePath: '/tpoRequests',
    Component: TPORequests,
    navTitle: 'Global',
  },
  {
    routePath: '/users',
    Component: Users,
    navTitle: 'Users',
  },

  {
    routePath: '/events/:eventId',
    Component: EventRole,
    navTitle: 'Global',
  },

  {
    routePath: '/manageprofile',
    Component: ManageProfile,
    navTitle: 'Global',
  },
  {
    routePath: '/reports',
    Component: Reports,
    navTitle: 'Reports',
  },
  {
    routePath: '/reports/studentreports',
    Component: StudentReportContainer,
    navTitle: 'Reports',
  },
  {
    routePath: '/courses',
    Component: Courses,
    navTitle: 'Courses',
  },
  {
    routePath: '/setting',
    Component: Settings,
    navTitle: 'Settings',
  },
  {
    routePath: '/events',
    Component: Events,
    navTitle: 'Roles',
  },
  {
    routePath: '/events/newevent',
    Component: NewEvent,
    navTitle: 'Roles',
  },
  {
    routePath: '/events/editevent/:eventID',
    Component: NewEvent,
    navTitle: 'Roles',
  },
  {
    routePath: '/events/drafts',
    Component: Drafts,
    navTitle: 'Roles',
  },
  {
    routePath: '*',
    Component: PageNotFound,
  },
  {
    routePath: `/ruleEngine/draft-page`,
    Component: RuleEngineDraft,
  },

  {
    routePath: '/ruleEngine/yet-to-set-rule',
    Component: YetToSetRulesTable,
  },

  {
    routePath: '/ruleEngine/setting-new-rule',
    Component: SettingNewRules,
  },
  {
    routePath: '/ruleEngine/setting-new-rule/:ruleId',
    Component: SettingNewRules,
  },
  {
    routePath: '/ruleEngine/rule-creation/:ruleId',
    Component: RulesCreationIndex,
  },
  // Strangler-fig: the Assessment module has been migrated to the v2 Next app
  // (institute-react-v2, served at the same origin under basePath /v2). The
  // sidebar entry in modules/Nav/navItems.js points to /v2/assessments, so
  // the route below is unreachable from the nav and kept only as a safety
  // net for any old in-flight link (e.g. open browser tabs, bookmarks). Flip
  // back to live if a regression forces us to fall back to v1's Assessment.
  // {
  //   routePath: '/assessment',
  //   Component: Assessment,
  // },
]
